import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "@tanstack/react-router";
import { PlanGrid } from "../components/PlanGrid";
import { useTranslate } from "../i18n";

export function PricingPage() {
  const navigate = useNavigate();
  const __ = useTranslate();
  return <Box sx={{ minHeight: "100vh", bgcolor: "background.default" }}>
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        px: { xs: 3, sm: 5 },
        py: 2.5,
      }}
    >
      <Typography variant="h6" fontWeight={800} color="primary">{__("Ebook Studio")}</Typography>
      <Button variant="outlined" onClick={() => void navigate({ to: "/login" })}>
        {__("Sign in with Google")}
      </Button>
    </Box>
    <Box sx={{ maxWidth: 1200, mx: "auto", p: { xs: 3, sm: 5 } }}>
      <Typography variant="h3" fontWeight={800} textAlign="center">{__("แผนราคา")}</Typography>
      <Typography color="text.secondary" textAlign="center" mt={1.5} mb={5}>
        {__("เลือกแผนที่เหมาะกับการสร้าง E-Magazine ของคุณ")}
      </Typography>
      <PlanGrid mode="marketing" />
    </Box>
  </Box>;
}
